import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.NetSuitePurchaseOrderRequestForm.ShippingDetailsSection',
    {
        shippingDetailsSectionTitle: 'Shipping Details',
        shipToFieldText: 'Ship to',
        shipToFieldPlaceholder: 'Select ship to',
        shipDateFieldText: 'Shipping date',
        shipMethodFieldText: 'Shipping method',
        shipMethodFieldPlaceholder: 'Select method',
        shippingAddressFieldText: 'Shipping address',
        shippingAddressFieldPlaceholder: 'Select address',
        fobFieldText: 'FOB',
        trackingNumbersFieldText: 'Traching numbers',
        dateFieldPlaceholder: 'Select date',
        textFieldPlaceholder: 'Enter value',
    }
);
